"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Head = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var Head = _styledComponents.default.thead.withConfig({
  displayName: "fluffy--Head",
  componentId: "fluffy--1ch0wxr"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
exports.Head = Head;
var templateObject_1;